import styles from "./vehicle-list.module.css";
import VehicleFilter from "../Filter";
import { TableLoader } from "../../../../components/LoaderC";
import List from "./component/List";
import Graph from "./component/Graph";
import { useState } from "react";

const VehicleListView = ({
  contentLoading,
  allData,
  isGridView,
  handleView,
  filterData,
  setFilterData,
  setAddModalOpen,
  setEditModalOpen,
  setEditData,
  isListChange,
  setSelectedId,
  setDeleteVehicleModalOpen,
  setTenantModalOpen,
  setTenantDetails
}) => {
  const [page, setPage] = useState(0);
  return (
    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          <div className="control-pane">
            {contentLoading && (
              <div className="Loader TableLoader">
                <TableLoader />
              </div>
            )}

            {!contentLoading && (
              <>
                <VehicleFilter
                  isGridView={isGridView}
                  handleView={handleView.bind(this)}
                  filterData={filterData}
                  setFilterData={setFilterData.bind(this)}
                  setAddModalOpen={setAddModalOpen.bind(this)}
                  setPage={setPage.bind(0)}
                />

                <div className={`${styles.IncomeListingBody}`}>
                  <div className={`${styles.IncomeListSec}`}>
                    <List
                      allData={allData}
                      filterData={filterData}
                      setEditData={setEditData.bind(this)}
                      setEditModalOpen={setEditModalOpen.bind(this)}
                      setSelectedId={setSelectedId.bind(this)}
                      setDeleteVehicleModalOpen={setDeleteVehicleModalOpen.bind(this)}
                      setTenantModalOpen={setTenantModalOpen.bind(this)}
                      setTenantDetails={setTenantDetails.bind(this)}
                    />
                  </div>
                  <div className={`${styles.IncomeGraphSec}`}>
                    <Graph
                      filterData={filterData}
                      isListChange={isListChange}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};



export default VehicleListView;